import * as firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyA26iavT7IMikFTk29dzm11Erf6G1V1VCs",
  authDomain: "kinder-ef1d2.firebaseapp.com",
  databaseURL: "https://kinder-ef1d2.firebaseio.com",
  projectId: "kinder-ef1d2",
  storageBucket: "kinder-ef1d2.appspot.com",
  messagingSenderId: "1052985693679"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
};

export const auth = firebase.auth()
export default firebase

